
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"clip-rule":"evenodd","fill-rule":"evenodd","stroke":"currentColor","fill":"currentColor","stroke-width":".4","stroke-linejoin":"round","stroke-miterlimit":"2","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 6a1 1 0 00-1-1H8.372a1.5 1.5 0 00-1.138.523 26793.79 26793.79 0 01-4.993 5.815 1 1 0 00-.001 1.302l4.994 5.835a1.5 1.5 0 001.14.525H21a1 1 0 001-1V6zm-13.628.5H20.5v11H8.374l-4.715-5.51zm5.637 4.427l1.71-1.71a.749.749 0 111.062 1.061l-1.711 1.711 1.728 1.728a.751.751 0 01-1.061 1.062l-1.728-1.729-1.728 1.729a.75.75 0 01-1.061-1.062l1.728-1.728-1.788-1.787a.749.749 0 111.062-1.062z","fill-rule":"nonzero"}})])
          )
        }
      }
    